module.exports = __webpack_public_path__ + "static/media/icon-stamps.10b09706.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-stamps.svg
// module id = 1005
// module chunks = 0